module.exports = __webpack_public_path__ + "static/media/hoverarrow.31a13a20.svg";